import conferencerules from './conferencerules';
import conferencerule from './conferencerule';

export default {
  namespaced: true,
  modules: {
    conferencerules,
    conferencerule,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/conferencerules/index.js